module.exports = __FOREMAN_VENDOR__REACT_LOADING_SKELETON__;